import React from "react";
import { connect } from "react-redux";
import { Form, Input, Row, Col, message, Typography } from "antd";
import { ReButton } from '@/components/refineElement';
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { setStorage, removeStorage, getStorage } from "@/lib/webStorage";
import { getLangList } from "@/lib/i18n";
import Login from "@/config/login";
import User from "@/config/user";
import PermissionConfig from "@/config/permission";
import { changLoginStatus } from "@/stores/login/action";

const { signIn } = Login;
const { getAccountInfo, getUserAccount } = User;
const { getRolePermissionInfo } = PermissionConfig;

interface props {
  loginToForgot: any;
  dispatch: any;
  history: any;
}

class LoginForm extends React.Component<props> {
  t: any = getLangList("login", "error");

  // [EVENT HANDLER]
  onSubmit = (value: any) => {
    const userInfo = { ...value };

    signIn(userInfo).then((res: any) => {
      if (!res.success) {
        return message.error(this.t.LOGIN_FAIL);
      }
      this.afterLogin(res, value);
    });
  };

  getRolePermissionInfoFunction = (roleId: number) => {
    const { history } = this.props;
    getRolePermissionInfo({ roleId }).then((res: any) => {
      setStorage("permission", res?.value ?? []);
      history.push("/home");
    });
  };

  // [HELPER FUNCTION]
  afterLogin = (res: any, value: any) => {
    setStorage("token", res.value);
    Promise.all([getAccountInfo(), getUserAccount()]).then((res: any) => {
      const isSuccess = res.every((item: any) => item.success);
      const info = res[0]?.value ?? [];
      const user = res[1]?.value ?? [];
      if (isSuccess) {
        setStorage("account", info?.username ?? '');
        setStorage("username", info?.nameCn ?? info?.nameEn ?? info?.username ?? '');
        setStorage("userAccountId", info?.userAccountId ?? '');
        setStorage("username", value.username, 0);
        setStorage("password", value.password, 0);
        setStorage("roleId", user?.roleId ?? 0);

        this.getRolePermissionInfoFunction(user?.roleId ?? 0);
        this.props.dispatch(changLoginStatus());
      } else {
        removeStorage('token');
      }
    });
  };

  render() {
    return (
      <div>
        <Typography.Title level={4}>{this.t.LOGIN_TITLE}</Typography.Title>
        <Form
          initialValues={{
            username: getStorage("username", 0) ?? '',
            password: getStorage("password", 0) ?? '',
          }}
          onFinish={this.onSubmit}
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: this.t.PLEASE_ENTER(this.t.USERNAME) }]}
          >
            <Input prefix={<UserOutlined />} placeholder={this.t.USERNAME} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: this.t.PLEASE_ENTER(this.t.PASSWORD) }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder={this.t.PASSWORD} type="password" />
          </Form.Item>

          <Row justify="end">
            {/* <Col>
              <Form.Item>
                <ReButton
                  // onClick={() => this.exportClick()}
                  attributeObject={{ type: "default" }}
                >
                  {this.t.FORGET_PASSWORD}
                </ReButton>
              </Form.Item>
            </Col> */}
            <Col offset={1}>
              <Form.Item>
                <ReButton attributeObject={{ htmlType: "submit" }}>
                  {this.t.LOGIN}
                </ReButton>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

export default connect()(LoginForm);